export default "__VITE_ASSET__CMBOfLLx__"